import Immutable from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { FRIENDS_DATAKEY, TYPE_NOTIFICATION } from '../constants/constants';
import initialState from './initialState';

/* Note */
/* Params: isLoadMore to check user have load more yet */
export default function notificationReducer(state = initialState.notificationState, action) {
  switch (action.type) {
    case types.GET_ALERT_SUCCESS: {
      const { dataAlert } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingAlert: false,
        dataAlert: action.params && action.params.isLoadMore ? [...dataAlert, ...action.data] : action.data,
        isHasMoreAlert: !(action.data instanceof Array && action.data.length < 24),
      };
      return state.merge({ ...updateParams });
    }
    case types.GET_EVENT_USER_EXPRESS_INTEREST_SUCCESS: {
      const { dataUserEventInterest } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingEventInterest: false,
        dataUserEventInterest: action.params && action.params.isLoadMore ? [...dataUserEventInterest, ...action.data] : action.data,
        isHasMoreEventInterest: !(action.data instanceof Array && action.data.length < 24),
        totalEventInterest: action.total,
      };
      return state.merge({ ...updateParams });
    }
    case types.GET_ALERT_NOTIFICATION_SUCCESS: {
      const { dataNotification } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingNotification: false,
        dataNotification: action.params && action.params.isLoadMore ? [...dataNotification, ...action.data] : action.data,
        isHasMoreNotification: !(action.data instanceof Array && action.data.length < 24),
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_VALIDATION_NOTIFICATION_SUCCESS: {
      const { dataValidation } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingValidation: false,
        dataValidation: action.params && action.params.isLoadMore ? [...dataValidation, ...action.data.data] : action.data.data,
        totalValidation: action.data.total,
        isHasMoreValidation: !(action.data.data instanceof Array && action.data.data.length < 24),
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_GROUP_INVITATION_NOTIFICATION_SUCCESS: {
      const { dataGroupInvitation } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingGroupInvitation: false,
        dataGroupInvitation: action.params && action.params.isLoadMore ? [...dataGroupInvitation, ...action.data.data] : action.data.data,
        isHasMoreGroupInvitation: action.data?.paginationInfo?.page < action.data?.paginationInfo?.totalPages,
        totalGroupInvitation: action.data.total,
      };
      return state.merge({ ...updateParams });
    }
    case types.GET_EVENT_INVITATION_NOTIFICATION_SUCCESS: {
      const { dataEventInvitation } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingEventInvitation: false,
        dataEventInvitation: action.params && action.params.isLoadMore ? [...dataEventInvitation, ...action.data.data] : action.data.data,
        isHasMoreEventInvitation: action.data?.paginationInfo?.page < action.data?.paginationInfo?.totalPages,
        totalEventInvitation: action.data.total,
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_PHOTO_LIKES_NOTIFICATION_SUCCESS: {
      const { dataPhotoLikes } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingPhotoLikes: false,
        dataPhotoLikes: action.params && action.params.isLoadMore ? [...dataPhotoLikes, ...action.data.data] : action.data.data,
        totalPhotoLikes: action.data.paginationInfo.totalItems,
        isHasMorePhotoLikes: action.data.paginationInfo.page < action.data.paginationInfo.totalPages,
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_FRIEND_NOTIFICATION_SUCCESS: {
      const { dataFriend, dataFriendRequest } = Immutable.asMutable(state);
      const { dataKey } = action;
      let updateParams = {};
      if (dataKey === FRIENDS_DATAKEY.FRIENDS) {
        updateParams = {
          isLoadingFriend: false,
          isCalledFriend: true,
          dataFriend: action.params && action.params.isLoadMore ? [...dataFriend, ...action.data.data] : action.data.data,
          totalFriend: action.data.total,
          isHasMoreFriend: !(action.data.data instanceof Array && action.data.data.length < (action.params.pageSize || 25)),
        };
      }
      if (dataKey === FRIENDS_DATAKEY.FRIENDS_REQUEST) {
        updateParams = {
          isLoadingFriendRequest: false,
          isCalledFriendRequest: true,
          dataFriendRequest: action.params && action.params.isLoadMore ? [...dataFriendRequest, ...action.data.data] : action.data.data,
          totalFriendRequest: action.data.total,
          isHasMoreFriendRequest: !(action.data.data instanceof Array && action.data.data.length < (action.params.pageSize || 25)),
        };
      }

      return state.merge({ ...updateParams });
    }

    case types.RESET_ALL_DATA: {
      return state.merge({
        isLoadingFriend: false,
        isCalledFriend: false,
        dataFriend: [],
        totalFriend: 0,
        isHasMoreFriend: true,
        isLoadingFriendRequest: false,
        isCalledFriendRequest: false,
        dataFriendRequest: [],
        totalFriendRequest: 0,
        isHasMoreFriendRequest: true,
      });
    }

    case types.GET_DATEFINDER_NOTIFICATION_SUCCESS: {
      const { dataDateFinder } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingDateFinder: false,
        dataDateFinder: action.params && action.params.isLoadMore ? [...dataDateFinder, ...action.data] : action.data,
        isHasMoreDateFinder: !(action.data instanceof Array && action.data.length < 24),
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_DATEFINDER_INTEREST_SUCCESS: {
      const { dataDateFinderInterest } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingDateFinderInterest: false,
        dataDateFinderInterest: action.params && action.params.isLoadMore ? [...dataDateFinderInterest, ...action.data] : action.data,
        isHasMoreDateFinderInterest: !(action.data instanceof Array && action.data.length < 24),
      };
      return state.merge({ ...updateParams });
    }

    case types.PATCH_ACTION_NOTIFICATION_SUCCESS: {
      // typeData Validations, Friends, action True Approve, False Reject, Params: index : id
      let { dataValidation, dataFriendRequest, dataGroupInvitation } = Immutable.asMutable(state);
      const { totalFriendRequest, totalGroupInvitation } = Immutable.asMutable(state);
      // let updateObjects = [];
      switch (action.typeData) {
        case TYPE_NOTIFICATION.VALIDATIONS:
          dataValidation = dataValidation.filter((item, index) => index !== action.params.index);
          return state.merge({
            dataValidation,
          });
        case TYPE_NOTIFICATION.FRIENDS:
          dataFriendRequest = dataFriendRequest.filter((item, index) => index !== action.params.index);
          return state.merge({
            dataFriendRequest,
            totalFriendRequest: totalFriendRequest - 1,
          });
        // case TYPE_NOTIFICATION.REQUEST_TO_JOIN:
        //   dataNotificationGroupJoinRequest = dataNotificationGroupJoinRequest.filter((item, index) => index !== action.params.index);
        //   return state.merge({
        //     dataNotificationGroupJoinRequest,
        //     totalGroupJoinRequest: totalGroupJoinRequest - 1,
        //   });
        case TYPE_NOTIFICATION.GROUP_INVITATION:
          dataGroupInvitation = dataGroupInvitation.filter((item, index) => index !== action.params.index);
          return state.merge({
            dataGroupInvitation,
            totalGroupInvitation: totalGroupInvitation - 1,
          });
        default:
          break;
      }
      return state;
    }
    case types.PATCH_ACTION_INTEREST_SUCCESS: {
      let { dataDateFinderInterest } = Immutable.asMutable(state);
      if (action.params.Action === 'Approve') {
        state = state.setIn(['dataDateFinderInterest', action.params.index, 'isMessageSent'], true);
      } else {
        dataDateFinderInterest = dataDateFinderInterest.filter((item, index) => index !== action.params.index);
        state = state.merge({
          dataDateFinderInterest,
        });
      }
      return state;
    }

    case types.MERGE_DATA_NOTIFICATION_SUCCESS: {
      return state.merge({ ...action.data });
    }

    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        dataAlert: [],
        isLoadingAlert: false,
        isHasMoreAlert: true,
        pageNumberAlert: 1,

        dataValidation: [],
        isLoadingValidation: false,
        isHasMoreValidation: true,
        pageNumberValidation: 1,

        dataFriend: [],
        totalFriend: 0,
        isLoadingFriend: false,
        isHasMoreFriend: true,
        pageNumberFriend: 1,
      };
      return state.merge({
        ...state,
        ...reset,
      });
    }
    case types.JOIN_A_GROUP_SUCCESS:
    case types.DELETE_INVITES_GROUP_RECEIVED_SUCCESS: {
      const { dataGroupInvitation, totalGroupInvitation } = Immutable.asMutable(state);
      const newData = dataGroupInvitation.filter(i => i.inviteID !== action.data.inviteId);
      const updateParams = {
        dataGroupInvitation: [...newData],
        totalGroupInvitation: totalGroupInvitation - 1,
      };
      return state.merge({ ...updateParams });
    }
    case types.DELETE_USER_FRIENDS: {
      const { dataFriend, dataFriendRequest } = Immutable.asMutable(state);
      const { dataKey, params } = action;
      let updateParams = {};
      if (dataKey === FRIENDS_DATAKEY.FRIENDS) {
        updateParams = {
          dataFriend: dataFriend.filter((item, index) => index !== params.index),
        };
      }
      if (dataKey === FRIENDS_DATAKEY.FRIENDS_REQUEST) {
        updateParams = {
          dataFriendRequest: dataFriendRequest.filter((item, index) => index !== params.index),
        };
      }
      return state.merge({ ...updateParams });
    }

    case types.DELETE_NOTIFICATION_ALERT: {
      const { dataAlert } = Immutable.asMutable(state);
      const { params } = action;
      let updateParams = {};
      updateParams = {
        dataAlert: dataAlert.filter((item, index) => index !== params.index),
      };

      return state.merge({ ...updateParams });
    }

    case types.DATE_FINDER_BLOCK_USER_SUCCESS: {
      const { dataDateFinderInterest, dataDateFinder } = Immutable.asMutable(state);
      const newListInterest = dataDateFinderInterest.filter(itm => itm.user.userId !== action.params.userId);
      state = state.merge({ dataDateFinderInterest: newListInterest });
      const indexMyDate = dataDateFinder.findIndex(itm => itm.id === action.params.idMyDate);
      if (dataDateFinder && indexMyDate !== -1) {
        state = state.setIn(['dataDateFinder', indexMyDate, 'interestCount'], dataDateFinder[indexMyDate].interestCount - 1);
      }
      return state;
    }

    default:
      return state;
  }
}
